/**
 * Created by jonas on 2021-03-23.
 */
import {DasUBoot} from "../../DasUBoot";
import {DasUBootGameAssets} from "../../DasUBootGameAssets";
import {DasUBootStatics} from "../../utils/DasUBootStatics";
import {GlowFrame} from "../../reels/symbols/symbolparts/GlowFrame";
import {GraphicsPool} from "../../utils/GraphicsPool";
import {DasUBootSound} from "../../sound/DasUBootSound";
import {gsap} from "gsap";

export class TorpedoPart extends PIXI.Container {
    private view:PIXI.Container;
    private basePlate:PIXI.Sprite;
    private numberSprite:PIXI.Sprite;
    private logoSprite:PIXI.Sprite;
    private isWild:boolean;
    private glowFrame:GlowFrame;

    constructor(value:number, isWild:boolean) {
        super();
        this.isWild = isWild;


        this.view = new PIXI.Container();
        this.basePlate = new PIXI.Sprite(DasUBoot.assetLoader.getTextures(DasUBootGameAssets.TORPEDO_PART_BACKGROUND)[0]);

        const logoTexture = isWild ? DasUBoot.assetLoader.getTextures(DasUBootGameAssets.TORPEDO_PART_XWILD_LOGO)[0] : DasUBoot.assetLoader.getTextures(DasUBootGameAssets.TORPEDO_PART_XWAYS_LOGO)[0]
        this.logoSprite = new PIXI.Sprite(logoTexture);
        //this.logoSprite.blendMode = PIXI.BLEND_MODES.MULTIPLY;

        this.numberSprite = new PIXI.Sprite();
        this.numberSprite.blendMode = PIXI.BLEND_MODES.MULTIPLY;

        this.glowFrame = <GlowFrame>DasUBoot.graphicsPool.getGenericPool(GraphicsPool.SYMBOL_FRAME).withdraw();
        this.glowFrame.reset();
        this.glowFrame.frameSize.set(144, 90);
        this.glowFrame.pivot.set(0, 0);
        this.glowFrame.position.set(0, 27);

        this.setValue(value);

        this.view.addChild(this.basePlate);
        this.view.addChild(this.logoSprite);
        this.view.addChild(this.numberSprite);

        this.addChild(this.view);
        this.addChild(this.glowFrame);

        this.glowFrame.hide(0);

    }

    public getFlash():gsap.core.Timeline{
        const tl = gsap.timeline()
        tl.add(() =>{
            this.glowFrame.tint = DasUBootStatics.torpedoWeldTint;
        });

        tl.add(this.glowFrame.show(0.1));
        tl.add(this.glowFrame.getAttention(true, false));
        tl.add(this.glowFrame.hide(0.1));
        tl.duration(0.5)
        return tl;
    }

    public getWeld():gsap.core.Timeline{
        const tl = gsap.timeline()

        tl.add(() =>{
            DasUBoot.soundPlayer.playSound(DasUBootSound.TORPEDO_WELD);
            this.glowFrame.tint = DasUBootStatics.torpedoWeldTint;
        });

        tl.add(this.glowFrame.show(0.1));
        tl.add(this.glowFrame.getWeldAnimation());
        tl.add(this.glowFrame.hide(0.1));

        return tl;
    }

    public setValue(value:number) {
        const tint = this.isWild ? DasUBootStatics.torpedoPartTintWild : DasUBootStatics.torpedoPartTintXWays;
        this.numberSprite.texture = TorpedoPart.getTexture(value);
        this.numberSprite.tint = tint;
       // this.logoSprite.tint = tint;
    }

    private static getTexture(value:number = 0) {
        switch (value) {
            case 1:
                return DasUBoot.assetLoader.getTextures(DasUBootGameAssets.TORPEDO_PART_x1)[0];
            case 2:
                return DasUBoot.assetLoader.getTextures(DasUBootGameAssets.TORPEDO_PART_x2)[0];
            case 3:
                return DasUBoot.assetLoader.getTextures(DasUBootGameAssets.TORPEDO_PART_x3)[0];
            case 4:
                return DasUBoot.assetLoader.getTextures(DasUBootGameAssets.TORPEDO_PART_x4)[0];
            case 5:
                return DasUBoot.assetLoader.getTextures(DasUBootGameAssets.TORPEDO_PART_x5)[0];
            case 6:
                return DasUBoot.assetLoader.getTextures(DasUBootGameAssets.TORPEDO_PART_x6)[0];
            case 7:
                return DasUBoot.assetLoader.getTextures(DasUBootGameAssets.TORPEDO_PART_x7)[0];
            case 8:
                return DasUBoot.assetLoader.getTextures(DasUBootGameAssets.TORPEDO_PART_x8)[0];
            case 9:
                return DasUBoot.assetLoader.getTextures(DasUBootGameAssets.TORPEDO_PART_x9)[0];
            default:
                return PIXI.Texture.EMPTY

        }

    }


}